import { useAuthentication } from '@givebacks/api';
import { useBreakPoints } from 'core';
import { ButtonMantine, Group } from 'ui';

import { useNavigateToAuth } from '../../../hooks/useNavigateToAuth/useNavigateToAuth';

const GetStartedActions = () => {
  const { isSmallScreen } = useBreakPoints();
  const { isAuthenticated } = useAuthentication();
  const { handleNavigateToAuth } = useNavigateToAuth();

  const isShowSignIn = !isAuthenticated && !isSmallScreen;
  const isShowGetStarted = !isAuthenticated;
  return (
    <Group gap="xs">
      {isShowSignIn && (
        <ButtonMantine
          size="md"
          variant="subtle"
          onClick={() => handleNavigateToAuth({ page: 'sign-in' })}
        >
          Sign In
        </ButtonMantine>
      )}
      {isShowGetStarted && (
        <ButtonMantine size="md" onClick={() => handleNavigateToAuth({ page: 'sign-up' })}>
          Get Started
        </ButtonMantine>
      )}
    </Group>
  );
};

export { GetStartedActions };
